<template>
  <v-container>
    <!-- SNACKBAR -->
    <v-snackbar
      v-model="snackState"
      :color="snackColor"
      :timeout="snackTime"
      bottom
      right
    >
      {{ snackText }}
    </v-snackbar>

    <v-card class="pa-4 my-10" elevation="2">
      <v-card-title> Asignación de Carteras por Usuarios </v-card-title>
      <v-card-text>
        <v-autocomplete
          v-model="selectedUsuario"
          :items="coordinadoresCabina"
          item-text="nombre"
          item-value="usuarioId"
          :loading="loadingCoordinadoresCabina"
          label="Seleccionar Usuario"
          no-data-text="No se encontró al usuario..."
          outlined
          dense
          prepend-inner-icon="fa-user"
          clearable
        ></v-autocomplete>
      </v-card-text>
      <v-card-text>
        <v-combobox
          v-model="selectedCartera"
          :items="carteras"
          item-text="nombre"
          item-value="id_carteras"
          :loading="loadingCarteras"
          label="Seleccionar Carteras"
          prepend-inner-icon="fa-wallet"
          color="primary"
          no-data-text="No se encontró la cartera..."
          hide-selected
          multiple
          outlined
          dense
          chips
        >
          <template v-slot:selection="{ attrs, item, parent, selected }">
            <v-chip
              v-if="item === Object(item)"
              v-bind="attrs"
              :input-value="selected"
              label
              small
            >
              <span class="pr-2">
                {{ item.nombre }}
              </span>
              <v-icon small @click="parent.selectItem(item)"> $delete </v-icon>
            </v-chip>
          </template>
        </v-combobox>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          @click="sendData"
          color="primary"
          :disabled="!selectedUsuario || selectedCartera.length == 0"
        >
          <v-icon left>far fa-save</v-icon>
          Guardar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>
<script>
import axios from "axios";

export default {
  name: "UsuariosPorCartera",
  data() {
    return {
      selectedCartera: [],
      selectedUsuario: null,
      loadingCarteras: false,
      loadingCoordinadoresCabina: false,
      carteras: [],
      coordinadoresCabina: [],
      snackColor: "primary",
      snackState: false,
      snackText: "example",
      snackTime: 4500,
    };
  },
  watch: {
    selectedUsuario(val) {
      if (val) {
        this.getCarterasFromUser();
      }
    },
  },
  computed: {},
  created() {
    this.listarCarteras();
  },
  methods: {
    getCarterasFromUser() {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      this.loadingCarteras = true;

      axios
        .get(
          `api/CarterasUsuarios?userId=${this.selectedUsuario}`,
          configuracion
        )
        .then((res) => {
          const carterasIds = res.data.map((c) => c.carteraId);
          this.selectedCartera = this.carteras.filter((c) =>
            carterasIds.includes(c.id_carteras)
          );
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          this.loadingCarteras = false;
        });
    },
    sendData() {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      const carterasIds = this.selectedCartera
        .filter((c) => c && c.id_carteras)
        .map((c) => c.id_carteras);

      axios
        .put(
          "api/CarterasUsuarios/Sincronizar",
          {
            usuarioId: this.selectedUsuario,
            ids: carterasIds,
          },
          configuracion
        )
        .then((res) => {
          this.snackText = "Cambios guardados correctamente!";
          this.snackState = true;
        })
        .catch((err) => {
          console.log(err);
          this.snackText = "No se pudieron guardar los cambios...";
          this.snackColor = "error";
          this.snackState = true;
        });
    },
    listarCarteras() {
      this.loadingCarteras = true;
      this.loadingCoordinadoresCabina = true;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get("api/Carteras/Activas", configuracion)
        .then((res) => (this.carteras = res.data))
        .catch((err) => console.log(err.data))
        .finally(() => {
          this.loadingCarteras = false;
        });

      axios
        .get("api/CarterasUsuarios/coordinadores", configuracion)
        .then((res) => (this.coordinadoresCabina = res.data))
        .catch((err) => console.log(err.data))
        .finally(() => {
          this.loadingCoordinadoresCabina = false;
        });
    },
  },
};
</script>
